var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"jira-issue-field-multi-select-edit"},[_c('b-form-select',{attrs:{"value":_vm.values,"options":_vm.options,"multiple":""},on:{"input":_vm.setValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }